import React from "react";
import { Backdrop, Button, CircularProgress } from "@mui/material";

export default function QuestionLoadingScreen({ saving = false, open = true, error = false, onRetry }) {
  return (
    <Backdrop
      open={open}
      aria-hidden={!open}
      transitionDuration={180}
      role="status"
      aria-live="polite"
      style={{
        position: "fixed",
        inset: 0,
        zIndex: 1200,
        backgroundColor: "rgba(245, 245, 250, 0.55)",
        backdropFilter: "blur(6px)",
        WebkitBackdropFilter: "blur(6px)",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        gap: "12px",
        padding: "24px",
        textAlign: "center",
      }}
    >
      {!error && <CircularProgress size={32} sx={{ color: "#996cfe" }} />}
      <strong style={{ fontSize: "18px", color: "#242424" }}>
        {error ? "The next question could not load." : saving ? "Saving your answer..." : "Loading your next question..."}
      </strong>
      <p style={{ margin: 0, maxWidth: "360px", fontSize: "14px", lineHeight: 1.5, color: "#555" }}>
        {error ? "Check your connection and try again." : "This may take a moment on a slow connection. Please keep this page open."}
      </p>
      {error && <Button variant="contained" onClick={onRetry}>Retry loading</Button>}
    </Backdrop>
  );
}
